import React from "react";
import { useTranslation } from "react-i18next";
import { appendClassName } from "../../../../../helpers/view-helpers";
import { withSelectedResult } from "../../../../providers/ResultSelectContext";
const FormatCell = ({ result, isSelectedResultId, toggleSelection }) => {
  const { t } = useTranslation();
  const url = result["product_page_url"].raw;

  return (
    <th width="8%">
      <div className={appendClassName("checkbox", result.id.raw)}>
        <label>
          <input
            type="checkbox"
            checked={isSelectedResultId(result.id.raw)}
            onChange={() => toggleSelection(result.id.raw)}
          />
        </label>
        <a href={url}>{t(result.model_name.raw)}</a>
      </div>
      {t(result.thumbnail_text.raw)}
    </th>
  );
};

const mapContextToProps = ({ isSelectedResultId, toggleSelection }) => ({
  isSelectedResultId,
  toggleSelection
});

export default withSelectedResult(mapContextToProps)(FormatCell);
